package org.koin.ksp.generated

import org.koin.core.module.Module
import org.koin.dsl.*


public val com_essntl_features_country_data_di_CountryModule : Module get() = module {
	single() { _ -> com.essntl.features.country.data.repository.CountryRepositoryImpl(supabase=get()) } bind(com.essntl.features.country.domain.repository.CountryRepository::class)
	single() { _ -> com.essntl.features.country.data.supabase.CountrySupabaseDataSource(supabaseClient=get()) } bind(com.essntl.features.country.data.supabase.CountrySupabaseDataSource::class)
}
public val com.essntl.features.country.data.di.CountryModule.module : org.koin.core.module.Module get() = com_essntl_features_country_data_di_CountryModule
